const {
  HORMIGUERO_CARD,
  NERUDA_CARD,
  VANITY_CARD,
} = require('constants/flagBasedFeatures');
const {
  HORMIGUERO_GDPR_PID,
  NERUDA_GDPR_PID,
  VANITY_GDPR_PID,
  DIAMOND_PACK_GDPR_PID,
  OPEN_DEBIT_GDPR_PID,
  PREMIUM_PACK_GDPR_PID
} = require('constants/gdprPlacementIds');
const {
  ADD_NEW_SHIPPING_ADDRESS,
  NERUDA_HIRE,
  DIAMOND_PACK_CREDIT,
  DIAMOND_PACK_DEBIT,
  VISA_OPEN_HIRE,
  PREMIUM_PACK_CREDIT,
  PREMIUM_PACK_DEBIT
} = require('constants/operationTypes');
const {
  HORMIGUERO_CARD_PRODUCT_ALIAS,
  NERUDA_CARD_PRODUCT_ALIAS,
  NERUDA_CARD_PRODUCT_ALIAS_CC,
  VANITY_CARD_PRODUCT_ALIAS,
  VANITY_CARD_PRODUCT_ALIAS_CC,
  DIAMOND_CARD_PRODUCT_ALIAS,
  DIAMOND_CARD_PRODUCT_ALIAS_CC,
  OPEN_CREDIT_PRODUCT_ALIAS,
  OPEN_CREDIT_PRODUCT_ALIAS_CC
} = require('constants/hiringProductInformation');
export function getCardData(cardType) {
  const cardDataMap = {
    'neruda': [{
      type: '500',
      subtype: '802',
      standard: '0000014',
    }],
    'vanity': [{
      type: '500',
      subtype: '805',
      standard: '0000001',
    }],
    'hormiguero': [{
      type: '500',
      subtype: '804',
      standard: '0000001',
    }],
    'diamond': [
      { type: '501', subtype: '002', standard: '0000003' },
      { type: '501', subtype: '002', standard: '0000022' },
      { type: '501', subtype: '002', standard: '0000021' },
    ],
    'open-credit': [
      { type: '500', subtype: '801', standard: '0000028' },
    ],
    'premium': [
      { type: '501', subtype: '003', standard: '0000003' },
      { type: '501', subtype: '003', standard: '0000022' },
      { type: '501', subtype: '003', standard: '0000021' },
    ],
  };

  return cardDataMap[cardType];
}

export function navigateBasedOnCardType(cardType, history, immFlagBasedFeatures, immProfile, hasCardOfType) {
  const cardTypeMap = {
    'neruda': () => !immFlagBasedFeatures.get(NERUDA_CARD),
    'vanity': () => !immFlagBasedFeatures.get(VANITY_CARD) || (immProfile.get('isNerudaUser') && hasCardOfType('Neruda')),
    'hormiguero': () => !immFlagBasedFeatures.get(HORMIGUERO_CARD),
    'diamond': () => false,
    'open-credit': () => false,
    'premium': () => false,
  };

  const shouldRedirect = cardTypeMap[cardType] ? cardTypeMap[cardType]() : true;
  if (shouldRedirect) {
    history.push('/myprofile/global');
  } else if (cardType === 'vanity' && immProfile.get('isNerudaUser') && hasCardOfType('Neruda')) {
    history.push('/myprofile/hire/neruda-landing');
  }
}
export function getPlacementIdCard(cardType) {
  const cardIdMap = {
    'vanity': VANITY_GDPR_PID,
    'neruda': NERUDA_GDPR_PID,
    'hormiguero': HORMIGUERO_GDPR_PID,
    'diamond': DIAMOND_PACK_GDPR_PID,
    'open-credit': OPEN_DEBIT_GDPR_PID,
    'premium': PREMIUM_PACK_GDPR_PID
  };

  return cardIdMap[cardType] || '';
}

export function getServiceCodes(cardType) {
  const commonCodes = [{
    serviceCode: NERUDA_HIRE
  }, {
    serviceCode: ADD_NEW_SHIPPING_ADDRESS
  }];

  const operationParams = {
    'hormiguero': commonCodes,
    'vanity': commonCodes,
    'neruda': commonCodes,
    'diamond': [{
      serviceCode: DIAMOND_PACK_CREDIT
    }, {
      serviceCode: DIAMOND_PACK_DEBIT
    }, {
      serviceCode: ADD_NEW_SHIPPING_ADDRESS
    }],
    'open-credit': [{
      serviceCode: VISA_OPEN_HIRE
    }, {
      serviceCode: ADD_NEW_SHIPPING_ADDRESS
    }],
    'premium': [{
      serviceCode: PREMIUM_PACK_CREDIT
    }, {
      serviceCode: PREMIUM_PACK_DEBIT
    }, {
      serviceCode: ADD_NEW_SHIPPING_ADDRESS
    }],
  };

  return operationParams[cardType] || [];
}

export function getHireCmsKey(cardType) {
  const cardTypeAliasMap = {
    'hormiguero': {
      hireCmsKey: HORMIGUERO_CARD_PRODUCT_ALIAS,
      collectiveLocation: '',
      contractPdfData: 'nrd_opencredit'
    },
    'vanity': {
      hireCmsKey: __CONTACT_CENTER__ ? VANITY_CARD_PRODUCT_ALIAS_CC : VANITY_CARD_PRODUCT_ALIAS,
      collectiveLocation: '',
      contractPdfData: 'nrd_opencredit'
    },
    'neruda': {
      hireCmsKey: __CONTACT_CENTER__ ? NERUDA_CARD_PRODUCT_ALIAS_CC : NERUDA_CARD_PRODUCT_ALIAS,
      collectiveLocation: '',
      contractPdfData: 'nrd_opencredit'
    },
    'open-credit': {
      hireCmsKey: __CONTACT_CENTER__ ? OPEN_CREDIT_PRODUCT_ALIAS_CC : OPEN_CREDIT_PRODUCT_ALIAS,
      collectiveLocation: '',
      contractPdfData: 'open_credit'
    },
    'diamond': {
      hireCmsKey: __CONTACT_CENTER__ ? DIAMOND_CARD_PRODUCT_ALIAS_CC : DIAMOND_CARD_PRODUCT_ALIAS,
      collectiveLocation: __CONTACT_CENTER__ 
                            ? 'Contrataciones_Paso_default_diamondpack_cc_1' 
                            : 'Contrataciones_Paso_default_diamondpack_1',
      contractPdfData: 'diamond_pack_card'
    },
    'premium': {
      hireCmsKey: __CONTACT_CENTER__ ? OPEN_CREDIT_PRODUCT_ALIAS_CC : OPEN_CREDIT_PRODUCT_ALIAS,
      collectiveLocation: __CONTACT_CENTER__ 
                            ? 'Contrataciones_Paso_default_premiumpack_cc_1' 
                            : 'Contrataciones_Paso_default_premiumpack_1',
      contractPdfData: 'premium_pack_card'
    },
  };

  return cardTypeAliasMap[cardType] || [];
}

